import { gql } from '@grandvisionhq/graphql';
import { checkoutMutationResult } from '../fragments/checkout-mutation-result.js';
import { unknownUpdateCartFailure } from '../fragments/cart-mutation-failures.js';

const SET_STORE = gql`
  mutation SetStore($storeInput: CheckoutStoreInput!) {
    setStore(storeInput: $storeInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;

export { SET_STORE };
//# sourceMappingURL=set-store.js.map
